import { render } from "./PopUpClientes.vue?vue&type=template&id=4c9dc80f"
import script from "./PopUpClientes.vue?vue&type=script&lang=js"
export * from "./PopUpClientes.vue?vue&type=script&lang=js"

import "./PopUpClientes.vue?vue&type=style&index=0&id=4c9dc80f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__